export enum UserTypeEnum {
  USER = 1,
  COACH = 2,
  RESPONSIBLE = 3,
  ADMIN = 4,
}
